import { useSnapshot } from 'valtio';

import ServiceModule from '.';
import { serviceState } from './workspace';
import ServiceUser from './workspace/types/ServiceUser';
import { ReadonlyServiceQueue } from './workspace/types/ServiceQueue';
import ServiceSession from './workspace/types/ServiceSession';

export type UseServiceResultType = {
  agentId: string;
  agentAvailable: boolean;
  readonly users: Readonly<ServiceUser[]>;
  queues: Readonly<ReadonlyServiceQueue[]>;
  sessions: Readonly<ServiceSession[]>;
  loading: boolean;
  loadingStatus: string;
  error: unknown;
  refetch: () => void;
};

function useService(): UseServiceResultType {
  const { users, queues, sessions, loading, loadingStatus, error } =
    useSnapshot(serviceState);
  const currentUser = users.find((user) => user.id === serviceState.id);
  let agentAvailable = false;
  if (currentUser) {
    agentAvailable = currentUser.available || false;
  }
  return {
    agentId: serviceState.id!,
    agentAvailable,
    users,
    queues,
    sessions: Object.values(sessions),
    loading,
    loadingStatus,
    error,
    refetch: () => ServiceModule.refetchWorkspace(),
  };
}

export default useService;
